import type { Product } from "../Product.js";
import { isShippingLater } from "./isShippingLater.js";

export function getShippingStartsAtOfProducts(
	products: Pick<Product, "shippingStartsAt">[],
	now: number,
): Product["shippingStartsAt"] {
	let latest: Product["shippingStartsAt"];
	for (const { shippingStartsAt } of products) {
		if (isShippingLater(shippingStartsAt, now) && (latest === undefined || shippingStartsAt > latest)) {
			latest = shippingStartsAt;
		}
	}
	return latest;
}
